import React from 'react';
import { withStyles } from '../../mui-styles-bridge.js';
import GetAppIcon from '@mui/icons-material/GetApp';
import axios from 'axios';
import FilePreviewer from './FilePreviewer';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
  filePreviewURL: {
    height: '100vh',
    border: '1px solid #C4C4C4',
    borderRadius: 10,
    margin: '8px 0px',
    '& > div > div > .photo-viewer-container': {
      margin: 'auto',
    },
  },
  downloadFile: {
    textDecoration: 'none',
    fontSize: '12px',
    color: '#757575',
    '&:hover': {
      textDecoration: 'none',
      color: '#2196F3',
    },
  },
  filePreviewError: {
    height: 100,
    border: '1px solid #C4C4C4',
    borderRadius: 10,
    margin: '8px 0px',
    color: 'rgb(225, 0, 80)',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class FilePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filePath: '',
      fileType: '',
      errorMessage: '',
      key: '',
    };
  }

  componentDidMount = async () => {
    const { data } = this.props;
    const rawUrl = data.data || data.fileUrl || '';
    if (!rawUrl || typeof rawUrl !== 'string' || rawUrl.trim() === '') {
      return;
    }
    const fileUrl = this.processUrl(rawUrl);
    await axios
      .get(fileUrl)
      .then((response) => {
        if (data && data.data) {
          // Try to detect file type from multiple sources (in order of priority):
          // 1. URL extension
          // 2. Content-Disposition header (filename)
          // 3. Content-Type header
          // 4. Fallback to data.file_type
          let fileType = this.getExtension(fileUrl);
          
          if (!fileType) {
            // Try Content-Disposition header for filename
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
              const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (filenameMatch && filenameMatch[1]) {
                const filename = filenameMatch[1].replace(/['"]/g, '');
                fileType = this.getExtension(filename);
              }
            }
          }
          
          if (!fileType) {
            // Try Content-Type header
            const contentType = response.headers['content-type'];
            if (contentType) {
              fileType = this.getExtensionFromMimeType(contentType);
            }
          }
          
          if (!fileType) {
            // Fallback to data.file_type
            fileType = data.file_type || '';
          }

          this.setState({
            fileType,
            filePath: fileUrl,
            key: data.key,
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
        this.setState({
          errorMessage: error.message,
        });
      });
  };

  getExtensionFromMimeType = (mimeType) => {
    // Map common MIME types to file extensions
    const mimeToExt = {
      'application/pdf': 'pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
      'application/vnd.ms-powerpoint': 'ppt',
      'text/csv': 'csv',
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/webp': 'webp',
      'text/plain': 'txt',
      'application/json': 'json',
      'application/xml': 'xml',
      'text/xml': 'xml',
      'application/zip': 'zip',
      'application/octet-stream': '', // Generic binary - can't determine type
    };
    
    // Extract base MIME type (ignore charset and other params)
    const baseMimeType = mimeType.split(';')[0].trim().toLowerCase();
    return mimeToExt[baseMimeType] || '';
  };

  processUrl = (urlStr) => {
    // Remove [ from start
    urlStr = urlStr.replace(/^\[/, '');
    // Remove everything after , or ]
    urlStr = urlStr.replace(/[,].*$/, '');
    urlStr = urlStr.replace(/\].*$/, '');

    // Rewrite file.workflow86.com URLs to api.workflow86.com to avoid CORS issues
    // The ALB redirect from file.workflow86.com doesn't include CORS headers
    urlStr = urlStr.replace(
      /https:\/\/file\.workflow86\.com\/file\/get/g,
      'https://api.workflow86.com/ai-service/file/get'
    );

    return urlStr;
  };

  getExtension = (path) => {
    var basename = path.split(/[\\/]/).pop(), // extract file name from full path ...
      // (supports `\\` and `/` separators)
      pos = basename.lastIndexOf('.'); // get last position of `.`

    if (basename === '' || pos < 1)
      // if file name is empty or ...
      return ''; //  `.` not found (-1) or comes first (0)

    return basename.slice(pos + 1); // extract extension ignoring `.`
  };
  render() {
    const { classes } = this.props;
    let { filePath, fileType, errorMessage, key } = this.state;
    filePath = this.processUrl(filePath);
    if (errorMessage) {
      return (
        <div className={classes.root}>
          <div className={classes.filePreviewError}>
            The file cannot be previewed ( {errorMessage} )
          </div>
        </div>
      );
    } else {
      try {
        return (
          <div className={classes.root}>
            {
              <div className={classes.filePreviewURL}>
                <FilePreviewer
                  className="filePreview"
                  fileType={fileType}
                  filePath={filePath}
                  fileName={key}
                />
              </div>
            }

            <a className={classes.downloadFile} href={filePath}>
              <GetAppIcon />
              DOWNLOAD
            </a>
          </div>
        );
      } catch (e) {
        return <h5>Error encountered</h5>;
      }
    }
  }
}

export default withStyles(styles)(FilePreview);
